import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import { IEditReportTaskDTO } from "../../services/reporting-data-service/ReportScheduleModels";
import ReportingDataService from "../../services/reporting-data-service/ReportingDataService";

export type MutationContextType = {
    previous: IEditReportTaskDTO | undefined;
};

export type UseSaveReportTaskParameters = {
    groupID: number,
} & BaseUseMutationParameters<IEditReportTaskDTO, IEditReportTaskDTO>;

export function useSaveReportTask({
    groupID,
    onError,
    onSuccess
}: UseSaveReportTaskParameters) {
    const queryClient = useQueryClient();

    return useMutation<IEditReportTaskDTO, RestError, IEditReportTaskDTO, MutationContextType>(
        (item) => {
            return ReportingDataService.saveReportTask(groupID, item);
        },
        {
            onMutate: async (item: IEditReportTaskDTO) => {

                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all],
                    active: true,
                    inactive: true
                    //type: 'all'
                });

                queryClient.refetchQueries({
                    queryKey: [keys.taskList, keys.task],
                    active: true,
                    inactive: true
                });

                return {
                    previous: item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}
